import { CountUp } from "countup.js";
import $ from "jquery";
import Rellax from "rellax";

$(() => {
  const figures = $(".hero .numbers");
  if (!!figures.length) {
    figures.each(function() {
      const figure = $(this);

      let triggered = false;
      const observer = new IntersectionObserver(
        entries => {
          if (!triggered && entries[0].isIntersecting) {
            triggered = true;

            figure.find(".number").each(function() {
              const countUp = new CountUp(this, $(this).attr("data-number"));
              if (!countUp.error) {
                countUp.start();
              } else {
                console.error(countUp.error);
              }
            });
          }
        },
        { threshold: [0.5] }
      );
      observer.observe(figure[0]);

      new Rellax(this, {
        speed: 0.5
      });
    });
  }

  const introContent = $(".home .hero .intro .content");
  const introImg = $(".home .hero .intro img");

  if (!!introContent.length) {
    introContent.each(function() {
      new Rellax(this, {
        speed: 0.6,
        center: true
      });
    });
  }
  if (!!introImg.length) {
    introImg.each(function() {
      new Rellax(this, {
        speed: 0.6,
        center: true
      });
    });
  }

  $('.play-button[data-target]').on('click', function(e) {
    e.preventDefault();
    const target = $(this).data('target');
    $(`#${target}`)[0].play();
    $(this).hide();
  });
});
